import { autopayApplicationTypeMap } from '../values/application';

/**
 * Returns the Autopay application type for the provided FastTrack application type
 *
 * @param {string} fastTrackOwnershipStatus
 * @returns {string}
 */
export const toAutopayApplicationType = (reasonForLoanChange) => autopayApplicationTypeMap[reasonForLoanChange];
